<template>
    <ValidationProvider
        v-slot="{ classes, errors }"
        ref="provider"
        :rules="rules"
        :custom-messages="customMessages"
        :name="name"
        :mode="custom"
        tag="div"
        :class="$attrs['class']" 
        class="w-full"
    >
        <div class="digi-date w-full mb-8" :class="classes">
            <label class="form-label" :for="name" v-html="errors[0] || label"></label>
            <div class="form-input flex flex-no-wrap max-w-none digi-date-container">
                <div class="flex form-input-inner flex-shrink-0 p-5px w-1/3">
                    <input type="hidden" v-model="thisValue" :name="name" :id="id"/>
                    <div class="input-wrapper w-full relative">
                        <span class="inline-flex mb-2 text-base">Day</span>
                        <input
                            type="tel"
                            placeholder="DD"
                            class="textbox bg-white h-12 w-full border-gray-500 border focus:border-green-500 outline-none p-2 text-center"
                            maxlength="2"
                            v-number-only="true"
                            @input="handleInput('d', $event)"
                            @change="handleChange('d', $event)"
                            v-model="day"
                            ref="day"
                        />
                    </div>
                </div>
                <div class="flex form-input-inner flex-shrink-0 p-5px w-1/3">
                    <div class="input-wrapper w-full relative">
                        <span class="inline-flex mb-2 text-base">Month</span>
                        <input
                            type="tel"
                            placeholder="MM"
                            class="textbox bg-white h-12 w-full border-gray-500 border focus:border-green-500 outline-none p-2 text-center"
                            maxlength="2"
                            v-number-only="true"
                            @input="handleInput('m', $event)"
                            @change="handleChange('m', $event)"
                            v-model="month"
                            ref="month"
                        />
                    </div>
                </div>
                <div class="flex form-input-inner flex-shrink-0 p-5px w-1/3">
                    <div class="input-wrapper w-full relative">
                        <span class="inline-flex mb-2 text-base">Year</span>
                        <input
                            type="tel"
                            placeholder="YYYY"
                            class="textbox bg-white h-12 w-full border-gray-500 border focus:border-green-500 outline-none p-2 text-center"
                            maxlength="4"
                            v-number-only="true"
                            @input="handleInput('y', $event)"
                            @change="handleChange('y', $event)"
                            v-model="year"
                            ref="year"
                        />
                    </div>
                </div>
            </div>
            <signpost
                :signPostId="checkSignpostId"
            >
            </signpost>
            <expand-transition origin="center left">
                <div v-if="microtext" class="form-microtext mt-4">
                    <small v-html="microtext"></small>
                </div>
            </expand-transition>
        </div>
    </ValidationProvider>
</template>
 
<script>
import { clamp } from '../../assets/js/utils';
import { isString, isNumber } from "underscore";
import ExpandTransition from './../expand-transition';
import { fireFullStoryFieldChangeEvent } from '../../assets/js/fullstory-helper';
import Signpost from './signpost'
export default {
    components: {
        signpost: Signpost,
        'expand-transition': ExpandTransition,
    },
    data() {
        return {
            thisValue: this.value,
            day: null,
            month: null,
            year: null,
            showSignposting: false,
            signPostId: null,
        };
    },
    computed: {
        checkSignpostId() {
            if (this.signPostId) {
                return this.signPostId;
            }
        }
    },
    props: {
        rules: {
            default: ""
        },
        customMessages: {
            default: () => {
                return {};
            }
        },
        attributes: {
            default: {}
        },
        value: {
            default: ""
        },
        name: {
            default: ""
        },
        label: {
            default: ""
        },
        id: {
            default: ""
        },
        options: {
            default: () => {
                return {};
            },
            type: Object
        },
        valid: {
            default: null
        },
        type: {
            default: "text"
        },
        microtext: {
            default: null
        },
        numeric_age: {
            default: null
        },
        customer: Object,
        test: {
            default: false,
        }
    },
    created() {
        this.populateFieldsFromData();
    },
    methods: {
        populateFieldsFromData() {
            if (/^\d{4}-\d{2}-\d{2}$/.test(this.thisValue)) {
                // Split it and set the values
                let split = this.thisValue.split('-');
                this.year = split[0];
                this.month = split[1];
                this.day = split[2];
                this.$nextTick(() => {
                    this.$refs.provider.validate(this.thisValue);
                });
            } else {
                this.$nextTick(() => {
                    this.$refs.provider.reset();
                });
            }
        },
        custom(context) {
            return {
                on: ["change"]
            };
        },
        zeroPad(number, length) {
            if (!isString(number) && !isNumber(number)) {
                return null;
            }
            if (!isNumber(length)) {
                return null;
            }
            if (!isString(number)) {
                number = number.toString();
            }
            while (number.length < length) {
                number = "0" + number;
            }
            return number;
        },
        handleInput(part, event) {
            let value = event.target.value;
            if (value.toString().length === 2) {
                // Go to the next field
                if (part == 'd') {
                    this.$refs['month'].focus();
                }
                if (part == 'm') {
                    this.$refs['year'].focus();
                }
            }
            if (
                this.day &&
                this.month &&
                this.year &&
                /^[0-9]{2}$/.test(this.day) &&
                /^[0-9]{2}$/.test(this.month) &&
                /^[0-9]{4}$/.test(this.year)
            ) {
                this.thisValue =  this.year.toString() + '-' + this.month.toString() + '-' + this.day.toString();
                // this.$refs.provider.validate(this.thisValue);
                this.$emit("input", this.thisValue);
            } else {
                this.thisValue = null;
                this.$emit("input", this.thisValue);
            }
        },
        handleChange(part, e) {
            // Set the part
            if (part === "d" && event.target.value) {
                window.amplitude.dobInteractionEvent('day');
                this.day = this.zeroPad(clamp(event.target.value, 1, 31), 2);
            }
            if (part === "m" && event.target.value) {
                window.amplitude.dobInteractionEvent('month');
                event.target.value = clamp(event.target.value, 1, 12);
                this.month = this.zeroPad(event.target.value, 2);
            }
            if (part === "y" && event.target.value) {
                window.amplitude.dobInteractionEvent('year');
                event.target.value = clamp(event.target.value, 1900, (new Date()).getUTCFullYear() - 17);
                this.year = event.target.value;
            }
            if (
                this.day &&
                this.month &&
                this.year &&
                /^[0-9]{2}$/.test(this.day) &&
                /^[0-9]{2}$/.test(this.month) &&
                /^[0-9]{4}$/.test(this.year)
            ) {
                this.thisValue = this.year + "-" + this.month + "-" + this.day;
                this.$refs.provider.validate(this.thisValue);
                //turned off this validation event to resolve errors
                // window.amplitude.dobValidationEvent(this.$refs.provider.$data.flags.valid === true ? 'valid' : 'invalid');
                this.$emit("change", this.thisValue);
                this.checkForSignposting();
            } else {
                this.thisValue = "";
                // this.$refs.provider.validate(this.thisValue);
                this.$emit("change", this.thisValue);
            }
            fireFullStoryFieldChangeEvent(this.name, this.thisValue);
        },
        // checks whether signposting should be shown, if we want to only show for test form configs add && this.test == true
        // ensure the test parameter is set to true for the component in the form config php file
        // ensure the vue component supports the test prop, if not implement it based on the other signposting components
        // implemented by matt
        checkForSignposting() {
            if (this.customer.employment_status == null && this.numeric_age >= 18 && this.numeric_age <= 20) {
                this.showSignposting = true;
                this.signPostId = 'dob';
                window.amplitude.showSignposting('age is between 18 and 20');
                return;
            }
            if (this.numeric_age <= 21 && this.customer.loanamount == 10000 && this.customer.income.salary <= 977) {
                this.showSignposting = true;
                this.signPostId = 'ratio';
                window.amplitude.showSignposting('age is 21 or less, loan amount is 10000 and monthly salary is less than £977');
                return;
            }
            if (this.numeric_age >= 18 && this.numeric_age <= 20) {
                this.showSignposting = true;
                this.signPostId = 'dob';
                window.amplitude.showSignposting('age is between 18 and 20.');
                return;
            }
            this.showSignposting = false;
            this.signPostId = null;
        }
    }
};
</script>
<style lang="scss">
.digi-date-container {
    margin: 0 -5px 0 -5px;
}
.p-5px {
    padding: 5px;
}
.digi-date.valid {
    .textbox {
        box-shadow: inset 0 0 0 1px #3DCFAF;
        border-color: #3DCFAF;
        border-width: 1px;
    }
}

.digi-date.invalid {
    .textbox {
        box-shadow: inset 0 0 0 1px #FC6471;
        border-color: #FC6471;
        border-width: 1px;
    }
}
</style>